import { array, boolean, number, object, string } from 'yup';

import type { RoomBlueprint, RoomBlueprintStep } from 'src/common/interfaces/room-blueprint';

export const blueprintInitialValue = (roomId: string | undefined): RoomBlueprint | undefined =>
  roomId ? { _id: '', roomId, steps: [] } : undefined;

export const stepInitialValue = (ruleId: string): RoomBlueprintStep => ({
  ruleId,
  parameters: {},
  isAutoAnswer: false,
});

export const roomBlueprintValidation = object({
  steps: array().of(
    object({
      parameters: object()
        .optional()
        .shape({
          key: string().trim().min(1, 'Parameter value cannot be empty'),
        }),
      taskId: string().optional(),
      questionNo: number().optional(),
      isAutoAnswer: boolean().required(),
    }),
  ),
});
